import React, { useState } from 'react';
import Tooltip from '@mui/material/Tooltip';
import InfoIcon from '@mui/icons-material/Info';
import Typography from '@mui/material/Typography/Typography';
import { detectBrowser, getDate, useIP, useQuestionnaires } from '../Common';
import { useNavigate } from 'react-router-dom';
import { createCandidate, updateLifeCycle } from '../apis';
import { AlertComponent, Heading, PhoneInput, PrettoSlider } from '.';

const EMAIL_REGEX =
	/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const SPECIAL_REGEX = /[*|":<>[\]{}`\\()';@&$%!#^_+=]/;
const SPECIAL_REGEX_NAME = /[0-9^`~!@#$%^&*()+=_}{"':?><|,./;|\]\\"["]/;

export default function NewReferenceCheck() {
	const [firstName, setFirstName] = useState('');
	const [lastName, setLastName] = useState('');
	const [email, setEmail] = useState('');
	const [phone, setPhone] = useState('');
	const [role, setRole] = useState('');
	const [questionnaire, setQuestionnaire] = useState('');
	const [sendRequestStatus, setSendRequestStatus] = useState({});
	const [isSubmitting, setIsSubmitting] = useState(false);
	const { data: ipAddress } = useIP();
	const response = 'requested';
	const navigate = useNavigate();
	const { data, isLoading } = useQuestionnaires();
	const questionnaires = data?.filter(val => !val.is_archived);

	const handlePhoneNumberChange = (value: string) => {
		document.getElementById('phone-field')!.classList.remove('error-field');
		const currentPhoneNumberLength = value
			?.split?.(' ')
			?.slice?.(1)
			?.join('')?.length;
		if (currentPhoneNumberLength && currentPhoneNumberLength > 10) return;
		return setPhone(value);
	};

	if (isLoading) return null;

	const createRequest = async () => {
		if (isSubmitting) return;
		let text = firstName + lastName;
		const patternNum = /[0-9]/;
		let patternOthers = /[A-Za-z]/;

		let result = patternNum.test(text);
		let result2 = patternOthers.test(text);
		if (result === true) {
			const x = document.getElementById('numberError')!;
			x.style.display = 'block';
			document.getElementById('first-name-field')!.classList.add('error-field');
			return false;
		}
		if (result2 === false) {
			const x = document.getElementById('emptySpaces')!;
			x.style.display = 'block';
			document.getElementById('first-name-field')!.classList.add('error-field');
			return false;
		}

		if (questionnaire === '') {
			const x = document.getElementById('questionnaireError')!;
			x.style.display = 'block';
			document
				.getElementById('select-questionnaire')!
				.classList.add('error-field');
			return false;
		}

		if (role === '' || role.trim().length < 4) {
			const x = document.getElementById('roleError')!;
			x.style.display = 'block';
			document.getElementById('job-title-field')!.classList.add('error-field');
			return false;
		}

		if (role.trim().length <= 3) {
			const x = document.getElementById('roleError')!;
			x.style.display = 'block';
			document.getElementById('job-title-field')!.classList.add('error-field');
			return false;
		}

		if (firstName === '') {
			const x = document.getElementById('firstNameError')!;
			x.style.display = 'block';
			document.getElementById('first-name-field')!.classList.add('error-field');
			return false;
		}
		if (lastName === '') {
			const x = document.getElementById('lastNameError')!;
			x.style.display = 'block';
			document.getElementById('last-name-field')!.classList.add('error-field');
			return false;
		}
		if (email === '') {
			const x = document.getElementById('emailError')!;
			x.style.display = 'block';
			document.getElementById('email-field')!.classList.add('error-field');
			return false;
		}
		if (email) {
			if (!email.match(EMAIL_REGEX)) {
				const x = document.getElementById('invalidEmailError')!;
				x.style.display = 'block';
				document.getElementById('email-field')!.classList.add('error-field');
				return false;
			}
		}
		if (phone.trim().length <= 0 && /[0-9]{4}/.test(phone) === false) {
			const x = document.getElementById('phoneError')!;
			x.style.display = 'block';
			document.getElementById('phone-field')!.classList.add('error-field');
			return false;
		}
		let PhoneNumber = phone;
		if (
			/[(][0]{3}[)][" "][0]{3}[-][0]{4}/.test(PhoneNumber) ||
			/[(][1]{3}[)][" "][1]{3}[-][1]{4}/.test(PhoneNumber) ||
			/[(][2]{3}[)][" "][2]{3}[-][2]{4}/.test(PhoneNumber) ||
			/[(][3]{3}[)][" "][3]{3}[-][3]{4}/.test(PhoneNumber) ||
			/[(][4]{3}[)][" "][4]{3}[-][4]{4}/.test(PhoneNumber) ||
			/[(][5]{3}[)][" "][5]{3}[-][5]{4}/.test(PhoneNumber) ||
			/[(][6]{3}[)][" "][6]{3}[-][6]{4}/.test(PhoneNumber) ||
			/[(][7]{3}[)][" "][7]{3}[-][7]{4}/.test(PhoneNumber) ||
			/[(][8]{3}[)][" "][8]{3}[-][8]{4}/.test(PhoneNumber) ||
			/[(][9]{3}[)][" "][9]{3}[-][9]{4}/.test(PhoneNumber)
		) {
			const x = document.getElementById('phoneErrorInvalid')!;
			x.style.display = 'block';
			document.getElementById('phone-field')!.classList.add('error-field');
			return false;
		}

		const recruiter = localStorage.getItem('creduser');
		const d = new Date();
		const year = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(d);
		const month = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(d);
		const day = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(d);
		const requestDate = year + '-' + month + '-' + day;
		setIsSubmitting(true);
		const resp = await createCandidate({
			recruiter: recruiter,
			firstName: firstName.trim(),
			lastName: lastName.trim(),
			email: email,
			phone: phone,
			role: role,
			questionnaire: questionnaire,
			requestDate: requestDate,
			response: response,
			recruiterName: recruiter,
		});

		if (resp.status >= 400) {
			setSendRequestStatus({ openProp: true });
			return;
		}

		const body = {
			uuid: resp.data.uuid,
			name: resp.data.recruiterName,
			userType: 'recruiter',
			date: getDate(),
			action: 'Sent request to Candidate',
			osBrowser: detectBrowser(),
			ipAddress: !!ipAddress ? ipAddress : null,
			locationISP: localStorage.getItem('cityName'),
			refereeUUID: resp.data.uuid,
		};
		await updateLifeCycle(body);

		if (resp.status === 201) {
			setSendRequestStatus({
				openProp: true,
				severity: 'success',
				title: 'Success',
				message: 'Your candidate reference request has been sent successfully!',
			});
			setTimeout(() => navigate('./requests'), 2000);
		}
	};

	return (
		<>
			<AlertComponent
				{...sendRequestStatus}
				closeAlert={() => setSendRequestStatus({ openProp: false })}
			/>
			<Heading heading='New Request' />
			<div className='container-fluid'>
				<div className='row'>
					<div className='col-md-12 px-0'>
						<div
							className='card tmzero'
							style={{ marginBottom: '0' }}
						>
							<div className='row'>
								<div className='col-md-5 card-box'>
									<div className='row'>
										<div className='col-md-12'>
											<h4>
												Questionnaire{' '}
												<Tooltip
													className='tooltip-mobile'
													placement='top'
													title='This is the reference template you will use. Each questionnaire has a predefined set of questions. By default, your candidate will be required to submit details of 2 referees to complete this questionnaire.'
												>
													<InfoIcon
														style={{
															color: '#ED642A',
															position: 'absolute',
															cursor: 'pointer',
														}}
													/>
												</Tooltip>
											</h4>
											<label className='label-static'>
												Type
												<span className='sup_char'>
													<sup>*</sup>
												</span>
											</label>

											<div className='form-group'>
												<select
													tabIndex={0}
													id='select-questionnaire'
													className='form-control select-top'
													value={questionnaire}
													onChange={evt => {
														setQuestionnaire(evt.target.value);
														const x =
															document.getElementById('questionnaireError');
														document
															.getElementById('select-questionnaire')!
															.classList.remove('error-field');
														x!.style.display = 'none';
													}}
												>
													<option value=''>Select</option>
													{questionnaires!.map(localState => (
														<option
															value={localState.uuid}
															key={localState.uuid}
														>
															{localState.questionnaire_title}
														</option>
													))}
												</select>
												<span className='fa fa-fw fa-angle-down field_icon eye'></span>
												<div className='notes'>
													{' '}
													Minimum references: 2
													<br />
													{questionnaire && (
														<span className='txt_primary'>Questionnaire: </span>
													)}
													<a
														data-toggle='modal'
														data-target='#question'
														href='/'
														onClick={e => e.preventDefault()}
													>
														{
															questionnaires?.find(
																val => val.uuid === questionnaire
															)?.questionnaire_title
														}
													</a>
												</div>
												<div
													className='modal fade'
													id='question'
													tabIndex={-1}
													role='dialog'
													aria-labelledby='exampleModalLabel'
													aria-hidden='true'
												>
													<div
														className='modal-dialog'
														role='document'
													>
														<div className='modal-content'>
															<div className='modal-header'>
																<h5
																	className='modal-title'
																	id='exampleModalLabel'
																>
																	Questionnaire
																</h5>
																<button
																	type='button'
																	className='close'
																	data-dismiss='modal'
																	aria-label='Close'
																>
																	<span aria-hidden='true'>&times;</span>
																</button>
															</div>
															<div className='modal-body'>
																<div className='row'>
																	<div className='model_scroll1 grow'>
																		<ul id='questionnaire'>
																			<li>
																				<div>
																					<table className='quest'>
																						<tbody>
																							{questionnaires
																								?.find(
																									val =>
																										val.uuid === questionnaire
																								)
																								?.questionList?.map(
																									(val, i) => (
																										<tr key={val.uuid}>
																											<td>{i + 1}.</td>
																											<td>
																												<Typography
																													variant='body2'
																													component='section'
																													className='question text-align-justify'
																													sx={{
																														lineHeight: '200%',
																													}}
																												>
																													{val.question}
																												</Typography>
																												{val.rateFlag && (
																													<div
																														style={{
																															marginBottom:
																																'1rem',
																														}}
																													>
																														<div className='col-md-6'>
																															<div className='range-slider'>
																																<span
																																	className='range-slider__value'
																																	style={{
																																		marginRight:
																																			'20px',
																																	}}
																																>
																																	0
																																</span>
																																<PrettoSlider
																																	valueLabelDisplay='auto'
																																	aria-label='pretto slider'
																																	step={1}
																																	marks
																																	min={0}
																																	max={5}
																																	value={0}
																																	defaultValue={
																																		0
																																	}
																																/>
																															</div>
																														</div>
																													</div>
																												)}
																											</td>
																										</tr>
																									)
																								)}
																						</tbody>
																					</table>
																				</div>
																			</li>
																		</ul>
																		<br />
																		<br />
																	</div>
																</div>
															</div>
															<div className='modal-footer'>
																<button
																	type='button'
																	className='btn btn-secondary-outline'
																	data-dismiss='modal'
																>
																	Close
																</button>
															</div>
														</div>
													</div>
												</div>
												<div
													className='notes'
													id='questionnaireError'
													style={{ display: `none` }}
												>
													Questionnaire is required
												</div>
											</div>
											<h4>
												Job Title
												<Tooltip
													className='tooltip-mobile'
													placement='top'
													title='This information will be displayed on the request summary page of the candidate.'
												>
													<InfoIcon
														style={{
															color: '#ED642A',
															position: 'absolute',
															cursor: 'pointer',
														}}
													/>
												</Tooltip>
											</h4>
											<div className='form-group'>
												<label className='bmd-label-floating'>
													Job Title
													<span className='sup_char'>
														<sup>*</sup>
													</span>
												</label>
												<input
													id='job-title-field'
													tabIndex={0}
													type='text'
													value={role}
													onChange={evt => {
														if (!SPECIAL_REGEX.test(evt.target.value)) {
															setRole(evt.target.value);
															const x = document.getElementById('roleError');
															x!.style.display = 'none';
															document
																.getElementById('job-title-field')!
																.classList.remove('error-field');
														}
													}}
													className='form-control'
													maxLength={50}
												/>
												<div
													className='notes'
													id='roleError'
													style={{ display: `none` }}
												>
													Please add a job title that is at least 4 characters
													long
												</div>
											</div>
										</div>
									</div>
								</div>

								<div className='col-md-7 card-box'>
									<h4>
										{' '}
										Candidate Details{' '}
										<Tooltip
											className='tooltip-mobile'
											placement='top'
											title='These details are used to communicate with the candidate so please make sure they are up to date and correct.'
										>
											<InfoIcon
												style={{
													color: '#ED642A',
													position: 'absolute',
													cursor: 'pointer',
												}}
											/>
										</Tooltip>
									</h4>
									<div className='row'>
										<div className='col-md-6'>
											<div className='form-group '>
												<label className='bmd-label-floating'>
													First Name
													<span className='sup_char'>
														<sup>*</sup>
													</span>
												</label>
												<input
													id='first-name-field'
													tabIndex={0}
													type='text'
													value={firstName}
													onChange={evt => {
														if (!SPECIAL_REGEX_NAME.test(evt.target.value)) {
															setFirstName(evt.target.value);
															const x = document.getElementById(
																'firstNameErrorInvalid'
															);
															document
																.getElementById('first-name-field')!
																.classList.remove('error-field');
															x!.style.display = 'none';
														} else {
															const x = document.getElementById(
																'firstNameErrorInvalid'
															);
															x!.style.display = 'block';
														}
													}}
													className='form-control'
													maxLength={35}
												/>
												<div
													className='notes'
													id='firstNameError'
													style={{ display: `none` }}
												>
													First Name is required
												</div>
												<div
													className='notes'
													id='firstNameErrorInvalid'
													style={{ display: `none` }}
												>
													Special characters/numbers not allowed
												</div>
												<div
													className='notes'
													id='lengthError'
													style={{ display: `none` }}
												>
													Name error
												</div>
												<div
													className='notes'
													id='numberError'
													style={{ display: `none` }}
												>
													Please dont use number in names
												</div>
												<div
													className='notes'
													id='emptySpaces'
													style={{ display: `none` }}
												>
													Please dont use empty Spaces/blanks in names
												</div>
											</div>
										</div>
										<div className='col-md-6'>
											<div className='form-group '>
												<label className='bmd-label-floating'>
													Last Name
													<span className='sup_char'>
														<sup>*</sup>
													</span>
												</label>
												<input
													id='last-name-field'
													tabIndex={0}
													type='text'
													value={lastName}
													onChange={evt => {
														if (!SPECIAL_REGEX_NAME.test(evt.target.value)) {
															setLastName(evt.target.value);
															const x = document.getElementById(
																'lastNameErrorInvalid'
															);
															document
																.getElementById('last-name-field')!
																.classList.remove('error-field');
															x!.style.display = 'none';
														} else {
															const x = document.getElementById(
																'lastNameErrorInvalid'
															);
															x!.style.display = 'block';
														}
													}}
													className='form-control'
													maxLength={35}
												/>
												<div
													className='notes'
													id='lastNameError'
													style={{ display: `none` }}
												>
													Last Name is required
												</div>
												<div
													className='notes'
													id='lastNameErrorInvalid'
													style={{ display: `none` }}
												>
													Special characters/numbers not allowed
												</div>
											</div>
										</div>
										<div className='col-md-6'>
											<div className='form-group'>
												<label className='bmd-label-floating'>
													Email address
													<span className='sup_char'>
														<sup>*</sup>
													</span>
												</label>
												<input
													id='email-field'
													tabIndex={0}
													type='text'
													value={email}
													onChange={evt => {
														if (!/[<>]/.test(evt.target.value)) {
															setEmail(evt.target.value);
															const x = document.getElementById('emailError');
															x!.style.display = 'none';
															const y =
																document.getElementById('invalidEmailError');
															y!.style.display = 'none';
															document
																.getElementById('email-field')!
																.classList.remove('error-field');
														} else {
															const y =
																document.getElementById('invalidEmailError');
															y!.style.display = 'block';
														}
													}}
													className='form-control'
													maxLength={254}
												/>
												<div
													className='notes'
													id='emailError'
													style={{ display: `none` }}
												>
													Email address is required
												</div>
												<div
													className='notes'
													id='invalidEmailError'
													style={{ display: `none` }}
												>
													Please enter a valid Email address
												</div>
											</div>
										</div>
										<div className='col-md-6'>
											<div className='mt-2.5'>
												<PhoneInput
													{...{
														phoneNumber: phone,
														handlePhoneNumberChange,
														defaultCountry: 'Canada',
													}}
												/>
												<div
													className='notes'
													id='phoneError'
													style={{ display: `none` }}
												>
													Phone# is required
												</div>
												<div
													className='notes'
													id='phoneErrorInvalid'
													style={{ display: `none` }}
												>
													Phone number is invalid
												</div>
											</div>
										</div>
										{/* <div className="col-md-8">
                              <div className="form-group">
                                <input
                                  type="text"
                                  value={phone}
                                  onChange={(evt) => {
                                    if (/^\d*$/.test(evt.target.value)) {
                                      setPhone(evt.target.value);
                                    }
                                    const x = document.getElementById(
                                      "phoneError"
                                    );
                                    x.style.display = "none";
                                  }}
                                  className="form-control"
                                  maxlength="10"
                                />
                                <div
                                  className="notes"
                                  id="phoneError"
                                  style={{ display: `none` }}
                                >
                                  Phone# is required
                                </div>
                              </div>
                            </div> */}
										{/* </div> */}
										{/* </div> */}
									</div>
									{/* <div className="form-group form-check box-pad">
                        <label className="form-check-label fcl">
                          <input
                            id="checkBoxConfirm"
                            type="checkbox"
                            onChange={checkBoxClicked}
                          />
                          &nbsp; I confirm my candidate is prepped and aware I
                          am using Credibled to collect their references.
                        </label>
                      </div> */}
									{/* <div className="clearfix"></div> */}
									<div className='box-pad mextpad '>
										{/** <a
                      href="#!"
                      id="add-list"
                      className="btn btn-secondary-outline"
                    >
                      Add to List
                    </a>
                    &nbsp; */}
										<input
											tabIndex={0}
											type='button'
											id='btnSendRequest'
											onClick={createRequest}
											className='btn btn-primary button-outline full-width-button'
											value=' Send Request'
											disabled={isSubmitting}
										/>
									</div>
									<div className='clearfix'></div>
								</div>
							</div>
						</div>

						<div
							className='card-plain new_block'
							id='show-list'
							style={{ display: `none` }}
						>
							<div className='row'>
								<div className='col-md-3 info-box'>
									<div className='actions'>
										<a
											className='open-icon'
											data-toggle='modal'
											data-target='#editInfo'
											href='#!'
										>
											<i className='fa fa-pencil-square-o'></i>
										</a>
										&nbsp;
										<a
											className='open-icon'
											id='del-list'
											href='#!'
										>
											<i className='fa fa-trash'></i>
										</a>
									</div>
									<h6 className='fw3 text-primary'>
										<br />
										<span className='text-secondary font-sm'></span>
									</h6>
									<span className='font-sm'>
										<br />
									</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}
